export default __webpack_public_path__ + "static/media/jira.82a0508b.svg";